import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import './Banner.css';

const Banner = () => {
    const bannerImage = process.env.PUBLIC_URL + '/images/welcome_banner.jpg'; // Update this path to your actual image
    const sentences = [
        "We Are The Family Friendly Ski Club!",
        "Just 28 minutes from Killington, 21 minutes from Pico.",
        "More affordable than a hotel - plus new friends and a chef!",
        "Become a member today - fun and memories guaranteed!",
    ];

    const [currentSentenceIndex, setCurrentSentenceIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSentenceIndex((prevIndex) => (prevIndex + 1) % sentences.length);
        }, 6000); // Change sentence every 6 seconds

        return () => clearInterval(interval); // Cleanup interval on component unmount
    }, [sentences.length]);

    return (
        <Box
            sx={{
                height: 'calc(100vh - 50px)', // Adjust height to be 100vh minus the navbar height
                backgroundImage: `url(${bannerImage})`,
                opacity: 0.8,
                backgroundPosition: 'center', // Center the image by default
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '@media (max-width: 600px)': {
                    backgroundSize: 'cover', // Ensure the image covers the area
                    backgroundPosition: 'center', // Center crop the image on mobile
                },
            }}
        >
            <img
                src="images/logo.svg"
                alt="Logo"
                style={{
                    position: 'absolute',
                    top: '30%', // Adjust this value as needed
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: '300px',
                }}
            />
            {/*Add some background behind the text with opacity*/}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '0%', // Adjust this value as needed
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '100vw',
                    textAlign: 'center',
                    backgroundColor: '#28364b', // Use rgba for opacity
                    minHeight: { xs: '3rem', sm: '3rem', md: '3rem', lg: '3rem' }, // Ensure the box can accommodate two lines of text
                    padding: '10px 0px', // Add some space around the text
                }}
            >
                <Typography
                    variant="h3"
                    color="white"
                    sx={{
                        display: 'inline-block',
                        lineHeight: 1.5, // Adjust line height if needed
                        animation: '6s infinite', // Add animation
                        fontSize: { xs: '1.5rem', sm: '1.5rem', md: '2rem', lg: '2rem' }, // Responsive font sizes
                    }}
                >
                    {sentences[currentSentenceIndex]}
                </Typography>
            </Box>
        </Box>
    );
};

export default Banner;
